import { read, create, remove } from '@/api/rest';

const projectExecutor = {
  index: async (options) =>
    await read('/project-executor?' + options.toString()),
  stats: async (options) =>
    await read('/project-executor/stats?' + options.toString()),
  create: async (data) => await create('/project-executor', data),
  remove: async (id) => await remove(`/project-executor/${id}`),
  students: async (options) =>
    await read('/project-executor/students?' + options.toString()),
  topUdcStats: async () => await read(`/project-executor/top-udc-stats`),
};

export default projectExecutor;
